import { FC, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DetailsBookSummary from './DetailsBookSummary';
import { BookingModel } from 'ts/dynamic/interfaces/DynamicBookResponse';
import { delay, getBase64Screenshot } from 'utils/utils';
import { submitScreenshots } from 'services/dynamic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { useGetPage } from 'hooks/useGetPage';
import { useLocation } from 'react-router-dom';
import useDynamicDataLayer from 'hooks/useDynamicDataLayer';
import { b2b, needToScreenshot } from 'constants/generic';

const DynamicSuccessPage: FC = () => {
  const [t] = useTranslation();
  const successRef = useRef<HTMLDivElement>(null);
  
  const { pathname } = useLocation();
  const { pushDynamicPurchase } = useDynamicDataLayer();
  useGetPage('dynamic/BookComplete');

  const [order, setOrder] = useState<BookingModel>();

  useEffect(() => {
    if (b2b && pathname !== '/dynamic/success') {
      return;
    }
    const orderStr = sessionStorage.getItem('dynSuccessOrder');
    if (orderStr) {
      const order = JSON.parse(orderStr);
      setOrder(order);

      (async () => {
        await delay(1000);
        pushDynamicPurchase();

        if (needToScreenshot && !order.screenshot) {
          const image = await getBase64Screenshot(successRef.current);

          submitScreenshots({
            screenshots: [],
            orderId: order.orderId,
            lastScreenshot: image,
            transactionId: order.transactionId,
          });

          sessionStorage.setItem('dynSuccessOrder', JSON.stringify({ ...order, screenshot: true }));
        }
      })();
    }
  }, []); // eslint-disable-line

  return (
    <div className="success page-wrapper" ref={successRef}>
      <div className="title">
        {t('flight.order_summary')} #{order?.orderId}
      </div>
      {order?.statusIsOK ? (
        <div className="text-md mb-20">{t('success')}!</div>
      ) : (
        <div className="mb-20">
          <FontAwesomeIcon className="color-danger mr-5" icon={faExclamationTriangle} />
          <span className="text-md">{t('failed_order')}</span>
        </div>
      )}
      {order?.orderHasBeenPaid && (
        <div className="text-md mb-20">{t('hotel.paid_successfully')}</div>
      )}
      {!!order && (
        <DetailsBookSummary
          model={order}
          couponAmount={order?.couponAmount + '' || '0'}
          onClickApply={() => {}}
          setCouponAmount={() => {}}
          isSuccess={true}
          bags={[]}
        />
      )}
      <div className="mb-20"></div>
    </div>
  );
};

export default withErrorBoundary(DynamicSuccessPage, 'DynamicSuccessPage');
